import Vue from 'vue'
import App from './App.vue'
import { createStore } from '../../vuex/store';
import VideoThumb from './components/VideoThumb';
import ErrorMessage from './components/ErrorMessage';
import VueI18Next from '@panter/vue-i18next';
Vue.use(VueI18Next);
Vue.component('VideoThumb', VideoThumb);
Vue.component('ErrorMessage', ErrorMessage);

// export a factory function for creating fresh app, router and store
// instances
export async function createApp (options) {
  const store = createStore(options);
  const i18n = new VueI18Next(options.i18next);
  const app = new Vue({
    store,
    i18n,
    // the root instance simply renders the App component.
    render: h => h(App),
  })
  return { app, store };
}
